import { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from '@components/Text'

const CitiesInfo = memo(({ className, addresses }) => {
  if (addresses && addresses.length > 0) {
    const results = addresses.map((element) => element.trim())
    return (
      <Text as='h2' className={`${className} text-paragraph-2 h4`}>
        {results.join(', ')}
      </Text>
    )
  }
  return null
})

CitiesInfo.displayName = 'CitiesInfo'

CitiesInfo.propTypes = {
  className: PropTypes.string,
  addresses: PropTypes.arrayOf(PropTypes.string)
}

export default styled(CitiesInfo)``